module.exports = __webpack_public_path__ + "static/media/16@1920w.f780e872.jpg";